import * as React from "react";
import ModalRichTextAlert from "@/ReactComponents/Modal/modal-rich-text-alert";

const ModalRichTextAlertView = props => <ModalRichTextAlert {...props} />;

export default ModalRichTextAlertView;
